/**
 * Synchronisation de l'etat « non lu » des notes de version entre les vues.
 *
 * Deux vues peuvent l'afficher en meme temps : la modal (bundle `global`, sur
 * n'importe quelle page) et le journal de bord (bundle de page). Elles font
 * bouger le meme compteur, qui reste positif tant qu'il reste des notes non
 * lues — y compris celles trop anciennes pour s'imposer en modal.
 *
 * Module volontairement sans effet de bord : il est importe par les deux
 * bundles, la ou importer directement le code de la modal risquerait de le
 * dupliquer et donc de l'executer deux fois.
 */

const BADGE_SELECTOR = "[data-release-note-badge]";

/** Emis apres l'acquittement d'un lot, pour les vues ouvertes en arriere-plan. */
export const ACKNOWLEDGED_EVENT = "release-notes:acknowledged";

/**
 * Signale aux autres vues que ces notes viennent d'etre acquittees.
 */
export function emitAcknowledged(ids: number[]): void {
    document.dispatchEvent(new CustomEvent<{ ids: number[] }>(ACKNOWLEDGED_EVENT, { detail: { ids } }));
}

/**
 * Met a jour la pastille : masquee a zero, plafonnee a 9+ au-dela.
 */
export function renderNewsBadge(count: number): void {
    const badge = document.querySelector<HTMLElement>(BADGE_SELECTOR);
    if (!badge) {
        return;
    }

    if (count <= 0) {
        badge.hidden = true;
        badge.textContent = "";
        badge.removeAttribute("aria-label");

        return;
    }

    badge.hidden = false;
    badge.textContent = count > 9 ? "9+" : String(count);
    badge.setAttribute("aria-label", `${count} nouveauté${count > 1 ? "s" : ""} non lue${count > 1 ? "s" : ""}`);
}
